import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import CommonButton from "components/commonButton/CommonButton";
import { useDispatch } from "react-redux";
import { uploadEmployeeExcel } from "redux/actions/EmployeesAction";
import { useSelector } from "react-redux";
import CommonModal from "components/commonModal/CommonModal";
import BulkEmployeeUploadResultModal from "./BulkEmployeeUploadResultModal";

const BulkEmployeeUpload = (props) => {
  const dispatch = useDispatch();

  const uploadData = useSelector((state) => state.uploadEmployeeExcel?.data);

  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const [failedRows, setFailedRows] = useState([]);
  const [openResultModal, setOpenResultModal] = useState(false);

  useEffect(() => {
    if (!uploadData?.success || !uploading) return;

    setUploading(false);

    const failed =
      uploadData?.data?.results?.filter((item) => item.status === "failed") ||
      [];

    if (failed.length > 0) {
      props.onUploadResult(failed);
    } else {
      props.handleClose();
    }
  }, [uploadData]);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = () => {
    if (!file) {
      return;
    }

    setUploading(true);

    const companyID = JSON.parse(localStorage.getItem("subCompany"));
    dispatch(uploadEmployeeExcel(file, companyID?.value));
  };

  const handleResultModalClose = () => {
    setOpenResultModal(false);
    setFailedRows([]);
    props.handleClose();
  };

  return (
    <>
      <Box className="bulkEmployeeUpload">
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: 600,
            mb: 2,
          }}
        >
          Bulk Employee Upload
        </Typography>

        <Box>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 600,
              mb: 1,
            }}
          >
            Bulk Employee Upload Notes
          </Typography>

          <Box
            sx={{
              fontSize: "13px",
              color: "#555",
              lineHeight: 1.6,
            }}
          >
            <Typography sx={{ fontSize: "13px" }}>
              1. Download the sample employee upload template from the portal.
            </Typography>

            <Typography sx={{ fontSize: "13px" }}>
              2. Fill employee details in the same Excel format only. Do not
              change column names or column order.
            </Typography>

            <Typography sx={{ fontSize: "13px" }}>
              3. Select values from dropdowns wherever available, like Role and
              Billing Type.
            </Typography>

            <Typography sx={{ fontSize: "13px" }}>
              4. After filling the data, upload the Excel file from the Bulk
              Upload option.
            </Typography>

            <Typography sx={{ fontSize: "13px" }}>
              5. If some rows fail, check the error message shown for each
              failed row.
            </Typography>

            <Typography sx={{ fontSize: "13px" }}>
              6. To re-upload, keep only the corrected failed rows in the Excel.
            </Typography>

            <Typography sx={{ fontSize: "13px" }}>
              7. Remove employees that were already uploaded successfully before
              re-uploading.
            </Typography>

            <Typography sx={{ fontSize: "13px" }}>
              8. Do not re-upload the full old file again, because already added
              employees may fail due to duplicate email or employee ID.
            </Typography>

            <Typography sx={{ fontSize: "13px" }}>
              9. Save the corrected Excel and upload again.
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            mt: 3,
          }}
        >
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              mb: 1,
            }}
          >
            Download Template
          </Typography>

          <Typography
            component="a"
            href="https://buoyantworx-my.sharepoint.com/:x:/p/rudresh_pv/IQBYcIcwzmUyQ5vst4gUTmMzARUprRpmyHQwJsJ3CXOkyIk?download=1"
            download
            sx={{
              fontSize: "13px",
              color: "#1976d2",
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            Download Sample Employee Upload Template
          </Typography>
        </Box>

        <Box
          sx={{
            mt: 3,
          }}
        >
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              mb: 1,
            }}
          >
            Upload Employee Excel
          </Typography>

          <input type="file" accept=".xlsx,.xls" onChange={handleFileChange} />

          {file && (
            <Typography
              sx={{
                fontSize: "13px",
                color: "#555",
                mt: 1,
              }}
            >
              Selected File: {file.name}
            </Typography>
          )}

          <Box sx={{ mt: 2 }}>
            <CommonButton
              name="Upload"
              btnClass={"btnMd btnYellow"}
              onClick={handleUpload}
            />
          </Box>
        </Box>

        {uploading && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              background: "rgba(255,255,255,0.7)",
              zIndex: 10,
            }}
          >
            <CircularProgress size={35} />
          </Box>
        )}
      </Box>

      <CommonModal open={openResultModal} handleClose={handleResultModalClose}>
        <BulkEmployeeUploadResultModal
          failedRows={failedRows}
          handleClose={handleResultModalClose}
        />
      </CommonModal>
    </>
  );
};

export default BulkEmployeeUpload;
